// extracted by mini-css-extract-plugin
export var backupIcon = "_p4-1";
export var image = "_p4-0";